import { StateSlice } from "./app";

export type LoadingProps = {
  loading: boolean;
};

export type LoadingState = LoadingProps & {
  setLoading: (loading: boolean) => void;
};

export const createLoadingState: StateSlice<LoadingState> = (set) => ({
  loading: false,
  setLoading: (loading: boolean) => set({ loading }, false, { type: "setLoading", loading }),
});
